export function ChromeIcon({ className }: { readonly className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.802 8.069L6.746 14.9a6 6 0 0 0 6.481 2.974l-2.346 4.064C5.885 21.382 2 17.145 2 12c0-1.396.286-2.724.802-3.931M21.168 8A10 10 0 0 1 22 12c0 5.118-3.845 9.338-8.804 9.93l3.948-6.84c.544-.902.856-1.96.856-3.09a5.98 5.98 0 0 0-1.528-4zM12 8a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0-6a9.99 9.99 0 0 1 8 4h-8a6 6 0 0 0-5.701 4.125L3.953 6.062A9.99 9.99 0 0 1 12 2"
        fill="currentColor"
      />
    </svg>
  );
}
